import { Analytics, Dashboard, Email, Money, Rocket, ThumbsUp } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';
import { SECTION_ROLES } from './model/permissions';

/**
 * Модуль 4 · Дашборды и отчёты (ДШ-01…11, Приложение D; матрица 2.2 «Дашборд клиники»):
 * - дашборды клиники с вкладками по правам — директор, AI-администратор (ещё FRONT_DESK), скрайб, биржа (ещё HR), сеть;
 * - отчёт об экономии, карточка пилота с замерами «до», результаты NPS, рассылки — собственник, главврач, операционный директор;
 * - дашборд врача (свой) — в «Моём кабинете»; опрос NPS по ссылке из уведомления — директора и врачи.
 */
export const sections = [
  defineSection({
    id: 'analytics.dashboards',
    area: 'clinic',
    path: 'analytics/*',
    roles: SECTION_ROLES.dashboards,
    // В меню администратора «Отчётов» нет (docs/redesign-2026-09.md): дашборд обращений открывается по ссылке.
    navRoles: SECTION_ROLES.dashboards.filter((role) => role !== 'FRONT_DESK'),
    icon: Dashboard,
    titleKey: 'analytics:nav.dashboards',
    namespaces: ['portal'],
    navGroup: 'manage',
    order: 10,
    tabGroup: 'reports',
    load: () => import('./pages/DashboardsPage'),
  }),
  defineSection({
    id: 'analytics.savings',
    area: 'clinic',
    path: 'analytics/savings',
    roles: SECTION_ROLES.clinicReports,
    icon: Money,
    titleKey: 'analytics:nav.savings',
    namespaces: ['portal'],
    navGroup: 'manage',
    order: 11,
    tabGroup: 'reports',
    load: () => import('./pages/SavingsPage'),
  }),
  defineSection({
    id: 'analytics.pilot',
    area: 'clinic',
    path: 'analytics/pilot',
    roles: SECTION_ROLES.clinicReports,
    icon: Rocket,
    titleKey: 'analytics:nav.pilot',
    namespaces: ['portal'],
    navGroup: 'manage',
    order: 12,
    tabGroup: 'reports',
    load: () => import('./pages/PilotPage'),
  }),
  defineSection({
    id: 'analytics.nps',
    area: 'clinic',
    path: 'analytics/nps',
    roles: SECTION_ROLES.clinicReports,
    icon: ThumbsUp,
    titleKey: 'analytics:nav.nps',
    namespaces: ['portal'],
    navGroup: 'manage',
    order: 13,
    tabGroup: 'reports',
    load: () => import('./pages/NpsResultsPage'),
  }),
  defineSection({
    id: 'analytics.reports',
    area: 'clinic',
    path: 'analytics/reports',
    roles: SECTION_ROLES.clinicReports,
    icon: Email,
    titleKey: 'analytics:nav.reports',
    namespaces: ['portal'],
    navGroup: 'manage',
    order: 14,
    tabGroup: 'reports',
    load: () => import('./pages/ReportsPage'),
  }),
  defineSection({
    id: 'analytics.doctor',
    area: 'clinic',
    path: 'analytics/me',
    roles: SECTION_ROLES.doctor,
    icon: Analytics,
    // «Моя статистика» — одна страница без вкладок (docs/redesign-round2-2026-09-27.md №1); прежние адреса скрайба и биржи ведут сюда.
    titleKey: 'analytics:myStats.title',
    namespaces: ['portal'],
    navGroup: 'me',
    order: 10,
    load: () => import('./doctor/MyStatsPage'),
  }),
  defineSection({
    id: 'analytics.survey',
    area: 'clinic',
    path: 'nps/:id',
    roles: SECTION_ROLES.nps,
    icon: ThumbsUp,
    titleKey: 'analytics:survey.title',
    namespaces: ['portal'],
    order: 150,
    nav: false,
    load: () => import('./pages/NpsSurveyPage'),
  }),
];
